import { render } from "./UserNotificationPopUp.vue?vue&type=template&id=757981ab"
import script from "./UserNotificationPopUp.vue?vue&type=script&lang=js"
export * from "./UserNotificationPopUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__